import { NavigationItem } from '../types';
import { usePathname } from 'next/navigation';
import NextLink from 'next/link';
import Link from '@/components/Link';

export default function DesktopSimpleLink({
  link,
  index,
}: {
  link: NavigationItem;
  index: number;
}) {
  const pathname = usePathname();
  const pathnameWithoutLocale = '/' + pathname.split('/').slice(2);
  const isActive = pathnameWithoutLocale === link.href;

  return (
    <NextLink href={link.href} style={{ marginLeft: index > 0 ? '24px' : 'auto' }}>
      <Link
        variant='body1'
        color='inherit'
        component='span'
        underline={isActive ? 'always' : 'hover'}
        sx={{ fontWeight: 600 }}
      >
        {link.text}
      </Link>
    </NextLink>
  );
}
